import { Outlet, Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import ConditionalLayout from "./conditional-layout";
import RouteTransitionLoader from "./RouteTransitionLoader";
function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const auth = useAuth();
  const handleLogout = () => {
    auth.removeUser();
  };
  return (
    <div>
      <RouteTransitionLoader />
      <ConditionalLayout>{children}</ConditionalLayout>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
export default Layout;
